<script setup lang="ts">
import type {Message} from '@/client/mentor/MessagesClient'
import {useAssistantDebugSettings} from '@/components/assistant/composables/useAssistantDebugSettings'
import MessageTimeUsageBadge from '@/components/assistant/chat/message/MessageTimeUsageBadge.vue'
import MessageTokenUsageBadge from '@/components/assistant/chat/message/MessageTokenUsageBadge.vue'
import MessageToolUsageBadges from '@/components/assistant/chat/message/MessageToolUsageBadges.vue'

defineProps<{
  message: Message
}>()

const {showDebugDetails, showInvokedTools} = useAssistantDebugSettings()
</script>

<template>
  <div
    v-if="showDebugDetails"
    class="mt-2 flex flex-col gap-1 border-t border-dashed border-new-neutral-100 pt-1 text-[11px] text-new-neutral-500 print:hidden"
  >
    <div class="flex flex-wrap items-center gap-x-3 gap-y-0.5">
      <span><strong>Message ID:</strong> {{ message.id }}</span>
      <span v-if="message.meta?.agent"> <strong>Agent type:</strong> {{ message.meta?.agent }} </span>

      <MessageTimeUsageBadge :progress="message.progress" />
      <MessageTokenUsageBadge :used-tokens="message.meta?.usedTokens" />
    </div>

    <details v-if="message.progress?.length" class="text-left">
      <summary class="cursor-pointer">Progress ({{ message.progress.length }})</summary>
      <pre class="mt-1 max-h-48 overflow-auto whitespace-pre-wrap rounded bg-new-neutral-50 p-2 text-[11px]">{{
        JSON.stringify(message.progress, null, 2)
      }}</pre>
    </details>

    <MessageToolUsageBadges v-if="showInvokedTools" :tools="message.meta?.invokedTools" />
  </div>
</template>
